import React, { useState } from 'react';
import EmptyMvp from './EmptyMvp';
import MvpItem from './MvpItem';
import MyMvpsModal from './MyMvpsModal';
import { useIsMobile } from '@repo/common';

const MOBILE_PAGE_SIZE = 12;

const MyMvpsList = ({ mvpsList = [] }) => {
  const isMobile = useIsMobile();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mobileVisibleCount, setMobileVisibleCount] =
    useState(MOBILE_PAGE_SIZE);

  if (mvpsList.length === 0) {
    return (
      <div className='w-full flex flex-col overflow-hidden'>
        <EmptyMvp />
      </div>
    );
  }

  if (isMobile) {
    const visibleItems = mvpsList.slice(0, mobileVisibleCount);
    const hasMore = mobileVisibleCount < mvpsList.length;

    return (
      <div className='w-full flex overflow-x-auto scrollbar-hide snap-x'>
        <div className='flex gap-2'>
          {visibleItems.map((item) => (
            <MvpItem key={item.id} item={item} />
          ))}
        </div>
      </div>
    );
  }

  const isOverflow = mvpsList.length >= 5;

  return (
    <div className='w-full flex flex-col overflow-hidden'>
      <div className='relative flex gap-2.5 bg-grayscale-gray00 p-6 rounded-[15px] overflow-hidden flex-nowrap'>
        {mvpsList.slice(0, 5).map((item, index) => (
          <MvpItem key={index} item={item} isMvpModal />
        ))}

        {isOverflow && !isMobile && (
          <div className='absolute top-0 right-0 h-full w-[280px] flex items-center justify-end'>
            <div
              className='absolute inset-0 z-0'
              style={{
                background:
                  'linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, var(--Color-Primitive-grayscale-gray-00, #FFF) 50%)',
              }}
            />

            <div className='pr-[44px]'>
              <button
                type='button'
                onClick={() => setIsModalOpen(true)}
                className='relative z-10 font-medium whitespace-nowrap text-text-accent underline typo-b14Strong'
              >
                View all MVPs
              </button>
            </div>
          </div>
        )}
      </div>

      {isModalOpen && (
        <MyMvpsModal onClose={() => setIsModalOpen(false)} data={mvpsList} />
      )}
    </div>
  );
};

export default MyMvpsList;
